import { Storage } from 'react-jhipster';
export const login = config => {
  const clientId = Storage.session.get('clientIdFromSP');
  const urlCallback = Storage.session.get('urlCallbackFromSP');
  window.location.href =
    !clientId || !urlCallback
      ? config.urlRedirectDVC
      : config.urlAuth +
        '/oauth2/authorize?response_type=code&client_id=' +
        (clientId ? clientId : config.clientId) +
        '&redirect_uri=' +
        (urlCallback ? urlCallback : config.urlEid + '/login/callback').replace(':', '%3A').replace('/', '%2F') +
        '&scope=' +
        config.scope;

  // '&param1=' +
  // (userRequest && userRequest.user ? userRequest.user.userName : '') +
  // '&key_login=' +
  // (userRequest && userRequest.user ? userRequest.user.keyLogin : '');
};

export const isEmpty = obj => {
  return Object.keys(obj).length === 0;
};
